'use strict';

/** @type {import('./syntax')} */
module.exports = SyntaxError;



//////////////////
// WEBPACK FOOTER
// /Users/manskow/Local Sites/topphndball-v-53/app/public/wp-content/themes/nth-5.3/node_modules/es-errors/syntax.js
// module id = 11
// module chunks = 0